import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants';
import { useIssueKey } from '@atlassian/jira-issue-context-service';
import { useIsIssueOfDeveloperEscalationPractice } from '@atlassian/jira-issue-field-servicedesk-practices';
import { useProjectKey, useProjectType } from '@atlassian/jira-project-context-service';
import { useProjectPermissions } from '@atlassian/jira-project-permissions-service';

export const useIsDeveloperEscalationsEnabled = (): boolean => {
	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const [{ canEditIssues }] = useProjectPermissions(projectKey);
	const isIssueOfDeveloperEscalations = useIsIssueOfDeveloperEscalationPractice();
	const projectType = useProjectType(projectKey);
	const isServiceDeskProject = projectType === SERVICE_DESK_PROJECT;

	return isServiceDeskProject && !isIssueOfDeveloperEscalations && canEditIssues;
};
